function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#009CA6",
  d: "M212,0h816c117.1,0,212,94.9,212,212v816c0,117.1-94.9,212-212,212H212 c-117.1,0-212-94.9-212-212V212C0,94.9,94.9,0,212,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "white"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(175 451.682)"
}, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M480.3,60.5v216.8c0,7.7,2,15.4,5.8,22.1c4,7.2,9.2,13.8,15.3,19.4 c6.7,6.1,14.4,10.8,22.8,14c8.8,3.4,18.1,5.1,27.5,5.1H779V488h111V0H551.6c-9.4,0-18.7,1.7-27.5,5.1 c-8.4,3.1-16.1,7.7-22.8,13.5c-6.2,5.5-11.4,12.1-15.3,19.4C482.3,44.9,480.3,52.7,480.3,60.5z M590.8,111.9 c0-1.5,0.1-2.9,0.3-4.3c0-0.3,0-0.5,0-0.8c0.1-0.9,0.3-1.6,0.4-2.4c2-10.7,8.8-16.1,20.3-16.1h167.6v163.2H611.9 c-5.2,0-9.4-1.1-12.7-3.2c-4.8-3.2-7.5-8.7-8.1-16.5c0-0.4-0.2-0.8-0.2-1.2L590.8,111.9L590.8,111.9z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M598.2,665V517.7c0-8.9-1.7-17.6-5.1-25.8c-3.2-7.9-7.8-15.1-13.5-21.3 c-5.4-5.9-11.8-10.8-19-14.3c-6.6-3.3-13.9-5-21.3-5.1h-305c-7.4,0.1-14.8,1.8-21.4,5.1c-7.2,3.5-13.6,8.3-18.9,14.3 c-5.8,6.2-10.4,13.5-13.6,21.3c-3.4,8.2-5.2,16.9-5.1,25.8v205.6c0,8.9,1.7,17.6,5.1,25.8c3.2,7.9,7.8,15.1,13.6,21.4 c5.3,5.9,11.8,10.8,18.9,14.3c6.7,3.3,14,5.1,21.4,5.1h364.1v-88.2H305.9c-15,0-22.4-7.5-22.4-22.4V665H598.2z M283.5,563.2 c0-13.1,4.9-20.7,14.5-23c0.8-0.2,1.6-0.4,2.5-0.5c0,0,0,0,0.1,0c1.8-0.2,3.6-0.3,5.4-0.3h161.5c1.7,0,3.5,0.1,5.2,0.3 c0.1,0,0.1,0,0.2,0c0.9,0.1,1.6,0.3,2.4,0.5c9.7,2.2,14.6,9.9,14.6,23v12.9H283.5V563.2z"
}));

function SvgAppIconEquotipLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1240 1240",
    style: {
      enableBackground: "new 0 0 1240 1240"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIconEquotipLive);
export default __webpack_public_path__ + "static/media/appIconEquotipLive.260d430e.svg";
export { ForwardRef as ReactComponent };